module.exports = __webpack_public_path__ + "img/9788932910239.f02ff1b8.jpg";